import {
  handleAuthFailure,
  isAuthFailureResponse,
} from "@stocai/api";
import { deleteUserCookie, setLogoutSignal } from "../utils";

const getStoredAccessToken = () => {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user?.access_token || null;
  } catch {
    return null;
  }
};

export const withAuthHeaders = (headers = {}) => {
  const token = getStoredAccessToken();
  return {
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const apiFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    headers: withAuthHeaders(options.headers || {}),
  }).then(async (response) => {
    if (response.ok) return response;

    let detail = "";
    try {
      const data = await response.clone().json();
      detail = data?.detail || "";
    } catch {
      detail = "";
    }

    if (isAuthFailureResponse(response.status, detail)) {
      setLogoutSignal();
      deleteUserCookie();
      handleAuthFailure();
    }

    return response;
  });
};
